<template>
  <v-chip
    class="form-chip"
    :class="chipClasses"
    :label="!pill && !rounded"
    :pill="pill"
    :small="small"
    :color="color"
    :outlined="outlined"
    :text-color="textColor"
  >
    <v-icon v-if="icon" left :size="resolvedIconSize">{{ icon }}</v-icon>
    {{ text }}
  </v-chip>
</template>

<script>
export default {
  name: "Chip",
  props: {
    text: {
      type: String,
      required: true
    },
    small: {
      type: Boolean,
      default: false,
      required: false
    },
    color: {
      type: String,
      default: "white"
    },
    icon: String,
    pill: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    iconDot: {
      type: Boolean,
      default: false
    },
    iconSize: {
      type: [Number, String],
      default: null
    },
    /** Remove margem padrão (útil em células de tabela). */
    dense: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    chipClasses() {
      return {
        "ma-2": !this.dense,
        "form-chip--pill": this.pill,
        "form-chip--rounded": this.rounded,
        "form-chip--dot": this.iconDot,
        [`form-chip--${this.color}`]: this.iconDot && this.color
      };
    },
    textColor() {
      if (this.outlined) {
        return this.color;
      }
      return "white";
    },
    resolvedIconSize() {
      if (
        this.iconSize !== null &&
        this.iconSize !== undefined &&
        this.iconSize !== ""
      ) {
        return this.iconSize;
      }
      if (this.iconDot) {
        return 8;
      }
      if (this.small && this.icon) {
        return 14;
      }
      if (this.icon) {
        return 18;
      }
      return undefined;
    }
  }
};
</script>

<style scoped lang="scss">
.form-chip--pill {
  border-radius: 999px !important;
}

.form-chip--rounded {
  border-radius: 12px !important;
}

.form-chip--dot {
  ::v-deep .v-icon {
    margin-right: 6px !important;
  }

  &.form-chip--success ::v-deep .v-icon,
  &.form-chip--green ::v-deep .v-icon {
    color: #1b5e20 !important;
  }

  &.form-chip--grey ::v-deep .v-icon {
    color: #616161 !important;
  }

  &.form-chip--cyan ::v-deep .v-icon {
    color: #006064 !important;
  }
}

.form-chip ::v-deep .v-icon--left {
  margin-left: 2px;
  margin-right: 4px !important;
}
</style>
